import { useAuth } from '@/lib'
import { logger } from '@/ui'
import { useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

interface OrganisationToOpen {
	slug: string
	workosId: string | null
}

/** Resolves to `false` when the switch failed and the user was sent to the company selector instead. */
export function useOpenOrganisation() {
	const { switchOrganisation } = useAuth()
	const navigate = useNavigate()

	return useCallback(async (organisation: OrganisationToOpen, destination?: string): Promise<boolean> => {
		try {
			if (organisation.workosId) {
				await switchOrganisation(organisation.workosId)
			}
		} catch (error) {
			logger.warn('Organisation switch failed', {
				category: 'auth',
				data: { error: error instanceof Error ? error.message : String(error) },
			})
			await navigate({ to: '/company', search: { openFailed: organisation.slug } })
			return false
		}

		await navigate(
			destination
				? { to: destination }
				: { to: '/company/$companyId', params: { companyId: organisation.slug } },
		)
		return true
	}, [switchOrganisation, navigate])
}
